import React, { Suspense, lazy } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
//import IdleTimer from 'react-idle-timer';
//import { withRouter } from 'react-router';
import Dashboard from "./Dashboard";
import User from './User/User';
import { LayoutSplashScreen } from "../../../theme";
import IndividualCustomer from './IndividualCustomer/IndividualCustomer';
import ApartmentCustomer from './ApartmentCustomer/ApartmentCustomer';
import CorporateCustomer from './CorporateCustomer/CorporateCustomer';
import LoginScreen from './LoginScreen';
import CreateOrder from './transaction/order/CreateOrder';
import DeliveryAddress from './DeliveryAddress/DeliveryAddress';
import master from "./master/master";
import Faqs from "./master/FAQS";
import CustomerLeads from "./Manage/CustomerLeads";
import PartnerLeads from "./Manage/PartnerLeads";
import PartnerLoginAssets from "./PartnerLogin/PartnerLoginAssets";
import PartnerLoginDetail from "./PartnerLogin/PartnerLoginDetail";
import DriverFaq from "./master/DriverFAQ";
import Wallet from "./wallet/wallet";
import WaterTank from './WaterTank/WaterTank';
import RegisterCompliant from './RegisterCompliant/RegisterCompliant';
import RegisterMaster from "./master/RegisterMaster";
import ChildComplaint from  "./master/ChildComplaint";
import ConfigSetting from './Configsetting/ConfigSetting';

import Marketleadtracker from './Marketlead/Marketleadtracker';



const Transaction = lazy(() => import("./transaction/transaction"));
const Invoice = lazy(() => import("./transaction/invoice"));
const Partner = lazy(() => import("./Partner/Partner"));
const ZoneManagement = lazy(() => import("./Zone_Management/ZoneManagement"));
const Manage = lazy(() => import("./Manage/Manage"));
const Settings = lazy(() => import("./Settings/Settings"));
const ProfileMaster = lazy(() => import("./ProfileMaster/ProfileMaster"))
const Renewals = lazy(() => import("./Renewals/Renewals"));

export default function HomePage() {

  return (<>

    <Suspense fallback={<LayoutSplashScreen />}> 
      <Switch>
        {
          /* Redirect from root URL to /dashboard. */
          <Redirect exact from="/" to="/dashboard" />
        }
        <Route path="/login-page" component={LoginScreen} />
        <Route path="/user" component={User} />
        <Route path="/dashboard" component={Dashboard} />
        <Route path="/indiv-customer" component={IndividualCustomer} />
        <Route path="/aprt-customer" component={ApartmentCustomer} />
        <Route path="/config-setting" component={ConfigSetting} />
        <Route path="/corp-customer" component={CorporateCustomer} />
        <Route path="/partner" component={Partner} />
        <Route path="/transaction" component={Transaction} />
        <Route path="/invoice" component={Invoice} />
        <Route path="/zone-management" component={ZoneManagement} />
        <Route path="/manage" component={Manage} />
        <Route path="/profile-master" component={ProfileMaster} />
        <Route path="/transaction/order/order-create" component={CreateOrder} />
        <Route path="/delivery-address" component={DeliveryAddress} />
        <Route path="/crm/customer-leads" component={CustomerLeads} />
        <Route path="/crm/partner-leads" component={PartnerLeads} />
        <Route path="/master/price-master" component={master} />
        <Route path="/master/faq" component={Faqs} />
		 <Route path="/master/parentcompliant"   component={RegisterMaster} />
        <Route path="/master/childcompliant" component={ChildComplaint} />
        <Route path="/master/driverfaq" component={DriverFaq} />
        <Route path="/partner-login/assets" component={PartnerLoginAssets} />
        <Route path="/partner-login/details" component={PartnerLoginDetail} />
        <Route path="/renewals" component={Renewals} />
		<Route path="/Wallet" component={Wallet} />
		<Route path="/settings" component={Settings} />
		<Route path="/water-tank" component={WaterTank} />
		<Route path="/config-setting" component={ConfigSetting} />
		<Route path="/register-compliant" component={RegisterCompliant} />
		<Route path="/market-target-lead" component={Marketleadtracker} />
	
        <Redirect to="/error/error-v1" />
      </Switch>
    </Suspense>
  </>
  );
}

// class HomePage extends React.Component{

//   constructor(props){
//     super(props)

//     this.state = {
//       timeout:1000 * 60 * 60* 2,
//         showModal: false,
//         userLoggedIn: false,
//         isTimedOut: false
//     }

//     this.idleTimer = null
//     this.onAction = this._onAction.bind(this)
//     this.onActive = this._onActive.bind(this)
//     this.onIdle = this._onIdle.bind(this)
// }

// _onAction(e) {
//   this.setState({isTimedOut: false})
// }

// _onActive(e) {
//   this.setState({isTimedOut: false})
// }

// _onIdle(e) {
//   // const isTimedOut = this.state.isTimedOut
//   // if (isTimedOut) {
//       this.props.history.push('/logout')
//   // } 
//   // else {
//   //   this.setState({showModal: true})
//   //   this.idleTimer.reset();
//   //   this.setState({isTimedOut: true})
//   // }

// }

//   render(){
//     return (<>

//       <IdleTimer
//       ref={ref => { this.idleTimer = ref }}
//       element={document}
//       onActive={this.onActive}
//       onIdle={this.onIdle}
//       onAction={this.onAction}
//       debounce={250}
//       timeout={this.state.timeout} />

//       <Suspense fallback={<LayoutSplashScreen />}>
//         <Switch>
//           {
//             /* Redirect from root URL to /dashboard. */
//             <Redirect exact from="/" to="/dashboard" />
//           }
//           <Route path="/login-page" component={LoginScreen} /> 
//           <Route path="/user" component={User} /> 
//           <Route path="/dashboard" component={Dashboard} />
//           <Route path="/customer" component={IndividualCustomer} />
//           <Route path="/aprt-customer" component={ApartmentCustomer} />
//           <Route path="/corp-customer" component={CorporateCustomer} />
//           <Route path="/partner" component={Partner} />
//           <Route path="/transaction" component={Transaction} />
//           <Route path="/zone-management" component={ZoneManagement} />
//           <Route path="/manage" component={Manage} />
//           <Route path="/profile-master" component={ProfileMaster} />
//           <Route path="/transaction/order/order-create" component={CreateOrder} />
//           <Route path="/delivery-address" component={DeliveryAddress} />
//           <Route path="/crm/customer-leads" component={CustomerLeads} />
//           <Route path="/crm/partner-leads" component={PartnerLeads} />
//           <Route path="/master/faq" component={Faqs} />
//           <Route path="/master/driverfaq" component={DriverFaq} />
//           ​<Route path="/partner-login/assets" component={PartnerLoginAssets} />
//           <Route path="/partner-login/details" component={PartnerLoginDetail} />
//           <Redirect to="/error/error-v1" />
//         </Switch>
//       </Suspense>
//       </>
//     );
//   }
// }

//export default withRouter(HomePage);
